import { API_URL } from '@/config/env';
import { conformanceApi } from '@/lib/api';

import type { UserRoleAccess } from './access.types';

export const getUserRoleAccess = () => {
  return conformanceApi.get<UserRoleAccess>(
    `${API_URL.replace('/orr', '')}/system/user`,
  );
};
